angular
    .module('festzelt-os.guestlists')
    .factory('createAndPrintTicketsForRsvps', [
            '$injector',
            ($injector) => new CreateAndPrintTicketsForRsvps($injector)
        ]
    );

class CreateAndPrintTicketsForRsvps {
    constructor($injector) {
        this.injector = $injector;
        this.api = $injector.get('$http')
        this.alert = $injector.get('Alert')

        this.key = 'create-and-print-tickets-for-rsvps';
        this.title = 'Create and print tickets';
        this.level = 'selected';
    }

    action(action, store, newValue) {
        const dataForRequest = {
            ...store.getters.selectedFilters,
            guestlist_id: _.get(store.state, 'vm.guestlist.id', null)
        };

        this.api.post('tickets/rsvps/create-and-print-bulk', {
            rsvps: dataForRequest
        })
            .then(() => {
                this.alert.success('started', 'create and print tickets started');
            })
            .catch(e => {
                this.alert.handle(e)
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/rsvps-list/create-and-print-tickets-for-rsvps.js